import { SVGProps } from "react"

const ParkingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 14C10.8287 14 14 10.8354 14 7C14 3.17135 10.8287 0 6.99322 0C3.16457 0 0 3.17135 0 7C0 10.8354 3.17135 14 7 14ZM7 12.6244C3.88287 12.6244 1.38238 10.1171 1.38238 7C1.38238 3.88287 3.87609 1.38238 6.99322 1.38238C10.1104 1.38238 12.6176 3.88287 12.6244 7C12.6244 10.1171 10.1171 12.6244 7 12.6244ZM5.52953 10.1036C5.94288 10.1036 6.17328 9.82575 6.17328 9.38529V8.12488H7.39981C8.74831 8.12488 9.63601 7.28461 9.63601 6.00387C9.63601 4.73669 8.74153 3.88287 7.41336 3.88287H5.54985C5.11617 3.88287 4.88577 4.16747 4.88577 4.61471V9.38529C4.88577 9.81897 5.11617 10.1036 5.52953 10.1036ZM6.17328 7.16263V4.84511H7.22362C7.94869 4.84511 8.39593 5.2788 8.39593 6.01065C8.39593 6.72894 7.95547 7.16263 7.22362 7.16263H6.17328Z"
      fill="#1C1C1E"
    />
  </svg>
)

export default ParkingIcon
